module.exports = __webpack_public_path__ + "static/img/09.b3601a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/09.jpg
// module id = lGb/
// module chunks = 0